import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  class OperadoresService extends Service {
    constructor() {
      super();
  
      this.url = env.baseIdentificacao + "operadores/";
    }

    async listarOperadorAtual() {
      const usuario = await this.get(`${this.url}eu?include=empresas%2Cfoto`);
      return usuario;
    }
  }
  
  export const operadoresService = new OperadoresService()
  